import React, {
  Component,
  PropTypes,
} from 'react'

// import RevSlider, {
//   Slide,
//   Caption,
// } from 'react-rev-slider'
import Slider from 'react-slick'
import {
  EXTRA_SMALL_DEVICE,
  SMALL_DEVICE,
} from '../constant'

// import _textBanner from './textBanner'

// const config = {
//   responsiveLevels: [1025, 778, 480],
//   dottedOverlay: 'custom',
//   delay: 5000,
//   startwidth: 1170,
//   startheight: 660,
//   hideThumbs: 10,
//   navigation: {
//     arrows: {
//       enable: true,
//     },
//   },
//   fullWidth: 'on',
//   forceFullWidth: 'on',
//   hideThumbsOnMobile: 'off',
//   hideNavDelayOnMobile: 1500,
//   hideBulletsOnMobile: 'off',
//   hideArrowsOnMobile: 'off',
//   hideThumbsUnderResolution: 0,
//   navigationType: 'none',
// }

const settings = {
  dots: true,
  infinite: true,
  speed: 1000,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  arrows: false,
  adaptiveHeight: true,
  dotsClass: 'slick-dots-Banner',
  // customPaging: i => (
  //   <div
  //     style={{
  //       width: '30px',
  //       color: 'blue',
  //       border: '1px blue solid',
  //     }}
  //   >
  //     {i + 1}
  //   </div>
  // ),
  // nextArrow: <SampleNextArrow />,
  // prevArrow: <CustomPrevArrow />,
  // variableWidth: true,
  // adaptiveHeight: true,
  // className: 'slickWidth',
}
const settingsSmallDevice = {
  dots: false,
  infinite: true,
  speed: 1000,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  arrows: false,
  adaptiveHeight: true,
  // centerMode: true,
  // variableWidth: true,
  // adaptiveHeight: true,
}
class banner extends Component {
  static propTypes = {
    banners: PropTypes.array,
    screen: PropTypes.string.isRequired,
  }

  loading = () => (
    <div>
      <div
        style={{
          position: 'relative',
          width: '100%',
          height: 'auto',
          marginTop: 0,
          marginBottom: 0,
        }}
        className="forcefullwidth_wrapper_tp_banner"
      >
        <div
          data-reactroot=""
          style={{
            padding: '0px',
            left: '0px',
            position: 'absolute',
            width: '1920px',
            overflow: 'visible',
          }}
          className="tp-banner-container"
        >
          <div
            style={{
              width: '100%',
              position: 'relative',
              maxHeight: '660px',
              backgroundColor: 'rgba(0, 0, 0, 0)',
              backgroundImage: 'none',
              height: '660px',
            }}
            className="tp-banner revslider-initialised tp-simpleresponsive"
            id="revslider-901"
          >
            <div className="tp-loader spinner0">
              <div className="dot1" />
              <div className="dot2" />
              <div className="bounce1" />
              <div className="bounce2" />
              <div className="bounce3" />
            </div>
          </div>
        </div>
        <div className="tp-fullwidth-forcer" style={{ width: '100%', height: '660px' }} />
      </div>
    </div>
  )
  outputPage = (bannerI) => {
    if(bannerI.url.length !== 0) {
      return bannerI.url
    } else if(bannerI.productPackages.length > 0 ||  bannerI.productExams.length > 0 || bannerI.productCourses.length > 0) {
      return `/banner/${bannerI._id}`
    }
    // return ''
  }
  render () {
    const {
      banners,
      screen,
    } = this.props
    const isEmptyBanner = banners.length === 0 ? true : false
    // const listTransition = ['slf', 'fade', 'flt', 'lfb', 'sfr']
    return isEmptyBanner ?
      this.loading() :
      <div className="bannerResponsive">
        { screen !== EXTRA_SMALL_DEVICE && screen !== SMALL_DEVICE ?
          <Slider {...settings}>
            {
              banners.map((bannerI, idBanner) => (
                <div className="list-product-slide-Poster banner" key={idBanner}>
                  {/* <a href={bannerI.url} style={{ marginRight: '15px' }}> */}
                  <a href={this.outputPage(bannerI)} style={{ marginRight: '15px' }}>
                    <img src={bannerI.bannerImage_21_9 ? bannerI.bannerImage_21_9 : bannerI.bannerImage} alt="" />
                    {/* <img src={bannerI.bannerImage_21_9} alt="" className="poster" /> */}
                  </a>
                </div>
              ))
            }
          </Slider>
          :
          <Slider {...settingsSmallDevice}>
            {
              banners.map(bannerI => (
                <div className="list-product-slide-Poster-Small-Device banner" style={{ marginBottom: '-100px' }} >
                  <a href={this.outputPage(bannerI)} style={{ marginRight: '15px' }}>
                    <img src={bannerI.bannerImage_21_9} alt="" />
                  </a>
                </div>
              ))
            }
          </Slider>
        }
      </div>
  }
}

export default banner




// WEBPACK FOOTER //
// ./src/components/banner.js